import { __assign, __rest } from "tslib";
import * as React from 'react';
import { useState } from 'react';
import { Button, ButtonSize, Divider, Dropdown, Text, TextTypography, Popover, } from 'wix-ui-tpa/cssVars';
import { classes, st } from './MultiselectDropdown.st.css';
import { MultiselectDropdownItem } from './MultiselectDropdownItem';
import { MultiselectDropdownDataHooks } from './MultiselectDropdownDataHooks';
export var MultiselectDropdown = function (_a) {
    var options = _a.options, className = _a.className, placeholder = _a.placeholder, note = _a.note, applyButtonContent = _a.applyButtonContent, onExpandedChange = _a.onExpandedChange, restProps = __rest(_a, ["options", "className", "placeholder", "note", "applyButtonContent", "onExpandedChange"]);
    var _b = useState(false), shown = _b[0], setShown = _b[1];
    var isItemSelected = options.some(function (_a) {
        var numberOfParticipants = _a.counterOptions.numberOfParticipants;
        return numberOfParticipants > 0;
    });
    var buttonContent = options
        .filter(function (_a) {
        var numberOfParticipants = _a.counterOptions.numberOfParticipants;
        return numberOfParticipants;
    })
        .map(function (_a) {
        var value = _a.value, numberOfParticipants = _a.counterOptions.numberOfParticipants;
        return "".concat(numberOfParticipants, " ").concat(value);
    })
        .join(', ') || placeholder;
    var toggleShown = function (isShown) {
        if (!restProps.disabled) {
            setShown(isShown);
            if (typeof onExpandedChange === 'function') {
                onExpandedChange(isShown);
            }
        }
    };
    return (React.createElement(Popover, { shown: shown, placement: "bottom", showArrow: false, wiredToSiteColors: true, className: st(classes.root, { shown: shown, isItemSelected: isItemSelected }, className), onClickOutside: function () { return (shown ? toggleShown(false) : null); }, "data-hook": restProps['data-hook'] ||
            MultiselectDropdownDataHooks.MULTISELECT_DROPDOWN, moveBy: { x: 0 }, contentClassName: classes.popoverContent },
        React.createElement(Popover.Element, null,
            React.createElement("div", { "data-hook": MultiselectDropdownDataHooks.BUTTON_WRAPPER, onClick: function () {
                    toggleShown(!shown);
                }, onKeyDown: function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        toggleShown(!shown);
                    }
                } },
                React.createElement(Dropdown, __assign({}, restProps, { "data-hook": MultiselectDropdownDataHooks.BUTTON, className: classes.dropdown, key: buttonContent, placeholder: buttonContent, mobileNativeSelect: false, options: [] })))),
        React.createElement(Popover.Content, null,
            React.createElement("div", { className: classes.content, "data-hook": MultiselectDropdownDataHooks.CONTENT_WRAPPER },
                React.createElement(Text, { "data-hook": MultiselectDropdownDataHooks.NOTE, tagName: "div", className: classes.note, typography: TextTypography.runningText }, note),
                options.map(function (optionProps) { return (React.createElement(MultiselectDropdownItem, __assign({ key: optionProps.id }, optionProps))); }),
                React.createElement(Divider, { "data-hook": MultiselectDropdownDataHooks.DIVIDER, className: classes.divider }),
                React.createElement(Button, { upgrade: true, "data-hook": MultiselectDropdownDataHooks.BUTTON_APPLY, size: ButtonSize.small, className: classes.applyButton, onClick: function () { return toggleShown(false); } }, applyButtonContent)))));
};
//# sourceMappingURL=MultiselectDropdown.js.map